<nav class="flex items-center justify-between px-4 py-3 w-full">
  <div class="flex items-center min-w-0">
    <button
      *ngIf="showBack"
      (click)="onGoBack()"
      mat-button
      class="!px-0 !min-w-0 gap-1"
      aria-label="Volver atrás"
    >
      <div class="flex flex-row items-center gap-2">
        <mat-icon svgIcon="ph-regular-arrow-left" class="text-title shrink-0"></mat-icon>
        <span class="text-title font-medium text-sm">{{ 'common.buttons.back' | translate }}</span>
      </div>
    </button>
    <span *ngIf="!showBack && title" class="text-title font-medium text-base">{{ title }}</span>
  </div>
  <div class="flex items-center h-8">
    <span *ngIf="!production" class="text-xs text-default-gray mr-2">DEV {{ clientName }}</span>
    <img class="h-full w-auto max-w-24 object-contain" src="assets/img/toolbar_logo.png" alt="Logo" />
  </div>
</nav>
